module.exports = __webpack_public_path__ + "img/2-ilpakamaniotro.fe23917e.jpg";